import styled from 'styled-components';
import { Button } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #f78e1e;
  padding: 16px 40px;

  @media (max-width: 500px) {
    padding: 16px 30px;
  }
`;

export const BackButton = styled(Button)`
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #ffffff;
  color: #000000;
  height: 40px;
  border-radius: 4px;

  &:hover,
  &:focus {
    background: #f5f5f5;
    border-color: #ffffff;
    color: #000000;
  }

  &:active {
    background: #e6e6e6;
    border-color: #ffffff;
    color: #000000;
  }

  .anticon {
    margin-right: 8px;
    color: #000000;
  }
`;

export const BackText = styled.span`
  color: #000000;
  font-weight: 500;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CartText = styled.span`
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
`;

export const Title = styled.h1`
  color: #ffffff;
  font-weight: 600;
  font-size: 20px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  .anticon {
    font-size: 18px;
  }
`;

export const Content = styled.div`
  background-color: #f5f5f5 !important;
  min-height: 100vh;
`;

export const TabsContainer = styled.div`
  padding: 24px;

  .ant-tabs-nav {
    margin-bottom: 24px;
    position: relative;
  }

  .ant-tabs-tab {
    font-weight: 500;
    font-size: 16px;
    padding: 12px 24px;
    box-shadow: none !important;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: #f78e1e;
      font-weight: 600;
    }
  }

  .ant-tabs-ink-bar {
    background-color: #f78e1e;
  }
`;

export const TabsHeaderContainer = styled.div`
  position: relative;
  
  .ant-tabs-nav {
    margin-bottom: 24px;
    
    @media (min-width: ${BREAKPOINTS.desktop}) {
      padding-right: 300px;
    }
  }
`;

export const TimersContainer = styled.div`
  display: none;
  
  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    flex-direction: row;
    gap: 8px;
    align-items: flex-end;
    height: 100%;
    z-index: 1;
    background-color: white;
    padding: 8px;
    border-radius: 4px;
    height: auto;
    background-color: transparent;
    
    > div {
      font-size: 14px !important;
      padding: 8px !important;
      margin-bottom: 0 !important;
      white-space: nowrap;
    }
  }
`;

export const MobileTimersContainer = styled.div`
  display: block;
  margin-bottom: 16px;
  
  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: none;
  }
`;

export const TabContent = styled.div`
  padding: 16px 0;
  min-height: 400px;
`;

export const PrimaryLabel = styled.div`
  width: 100%;
  background-color: #faad14;
  color: #000;
  padding: 12px 16px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  span {
    font-weight: 700;
  }

  .anticon {
    font-size: 16px;
  }
`;

export const SecondaryLabel = styled.div`
  background-color: #D9D9D9;
  color: #262626;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 16px;
  width: auto;
`;

export const LkpActiveLabel = styled.div`
  width: 100%;
  background-color: #b5f5ec;
  color: #262626;
  padding: 12px 16px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;

  .anticon {
    font-size: 16px;
  }
`;

export const SectionTitle = styled.h3`
  font-weight: 700;
  color: #000;
  font-size: 16px;
  margin: 24px 0 16px 0;

  &:first-child {
    margin-top: 16px;
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
`;

export const EmptyStateText = styled.h2`
  color: #262626;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const EmptyStateSubText = styled.p`
  color: #8c8c8c;
  font-size: 16px;
  margin: 0;
`;

export const StyledCountdown = styled.span`
  .ant-statistic-content {
    font-size: 0.875rem !important;
    font-weight: 700 !important;
    line-height: 1;
  }

  .ant-statistic-content-value {
    font-size: 0.875rem !important;
    font-weight: 700 !important;
  }
`;

export const ResponsiveGrid = styled.div`
  display: grid;
  gap: 24px;
  
  grid-template-columns: 1fr;
  grid-template-areas: 
    "products"
    "summary";

  @media (min-width: ${BREAKPOINTS.tablet}) {
    grid-template-columns: 1fr 350px;
    grid-template-areas: "products summary";
    align-items: start;
  }
`;

export const ProductsSection = styled.div`
  grid-area: products;
  min-width: 0;
`;

export const SummarySection = styled.div`
  grid-area: summary;
  
  @media (min-width: ${BREAKPOINTS.tablet}) {
    position: sticky;
    top: 24px;
  }
`;
